<template>
  <el-dialog :visible.sync="state" :title="plustitle" width="566px" custom-class="c-pro" :close-on-click-modal="false" @open="bindGetData">
    <div class="m-form">
      <el-form label-width="140px">
        <el-form-item label="项目组名称">
          <el-input v-model.trim="landData.name" style="width: 100%" :maxlength="100" placeholder="最多100个字符" />
        </el-form-item>
        <el-form-item label="负责人">
          <el-select
            v-model="landData.manageIds"
            filterable
            multiple
            :popper-append-to-body="false"
            style="width: 100%"
            size="small"
            placeholder="请选择负责人"
            clearable
          >
            <el-option v-for="drop in opData" :key="drop.id" :label="drop.name" :value="drop.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组员">
          <el-select
            v-model="landData.opIds"
            filterable
            multiple
            :popper-append-to-body="false"
            style="width: 100%"
            size="small"
            placeholder="请选择组员"
            clearable
          >
            <el-option v-for="drop in opData" :key="drop.id" :label="drop.name" :value="drop.id"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <template slot="footer">
      <div class="m-foot">
        <div class="m-foot-left">
          <slot name="remove"></slot>
        </div>
        <div class="m-foot-right">
          <el-button @click="$emit('input', false)">取消</el-button>
          <el-button type="primary" :loading="loading" @click="submit">
            <span v-if="loading">提交中...</span>
            <span v-else>确认</span>
          </el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { isArray, isEmpty } from '@/common/js/utils'

export default {
  name: 'ProjectGroupManagerSet',
  props: {
    value: {
      type: Boolean
    },
    title: {
      type: String
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },

    edit: {
      type: Boolean,
      default() {
        return false
      }
    },
    opData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    plustitle() {
      return `${this.edit ? '修改' : '新增'}${this.title}`
    }
  },
  methods: {
    bindGetData() {
      this.landData = {
        id: '',
        name: '',
        manageIds: [],
        opIds: []
      }
    },
    setForm(form) {
      this.landData = { ...form }
    },
    // 提交验证
    submit() {
      const { name, manageIds, opIds } = this.landData
      if (isEmpty(name)) {
        this.$message.error('项目组名称不能为空！')
        return
      }
      if (!isArray(manageIds) || manageIds.length === 0) {
        this.$message.error('负责人不能为空！')
        return
      }
      if (!isArray(opIds) || opIds.length === 0) {
        this.$message.error('组员不能为空！')
        return
      }
      this.$emit('on-ok', this.landData)
    }
  },
  data() {
    return {
      landData: {
        id: '',
        name: '',
        manageIds: [],
        opIds: []
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .c-pro {
  position: relative;

  .m-foot {
    display: flex;

    .m-foot-left {
      flex: 1;
      display: flex;
      justify-content: left;
    }

    .m-foot-right {
      display: flex;
      justify-content: right;
    }
  }
}
</style>
